import { Middleware } from 'redux';
import GetMemo from 'src/apis/GetMemo';
import GetMemosDeadline from 'src/apis/GetMemosDeadline';

import {
  successCreateMemo,
  successDestroyMemo,
  successReadMemo,
  successReadMemosByDeadline,
  successReadMemosByGroup,
  successReadMemosDiff,
  successReadMemosRelated,
  successReadMemosSearch,
  successUpdateMemo
} from '../actions/memo';
import {
  failCalling,
  finishCalling,
  noInternetCalling,
  startCalling
} from '../actions/network';
import DeleteMemo from '../apis/DeleteMemo';
import GetMemosDiff from '../apis/GetMemosDiff';
import GetMemosGroup from '../apis/GetMemosGroup';
import GetMemosRelated from '../apis/GetMemosRelated';
import GetMemosSearch from '../apis/GetMemosSearch';
import PostMemo from '../apis/PostMemo';
import PutMemo from '../apis/PutMemo';

const MIDDLEWARE = 'memos';

const memosMiddleware: Middleware = store => next => action => {
  switch (action.type) {
    case 'READ_MEMOS_SEARCH':
      readMemosSearch(store, action);
      break;

    case 'READ_MEMOS_RELATED':
      readMemosRelated(store, action);
      break;

    case 'READ_MEMOS_BY_GROUP':
      readMemosGroup(store, action);
      break;

    case 'READ_MEMOS_BY_DEADLINE':
      readMemosDeadline(store, action);
      break;

    case 'READ_MEMOS_DIFF':
      readMemosDiff(store, action);
      break;

    case 'CREATE_MEMO':
      createMemo(store, action);
      break;

    case 'READ_MEMO':
      readMemo(store, action);
      break;

    case 'UPDATE_MEMO':
      updateMemo(store, action);
      break;

    case 'UPDATE_MEMOS':
      updateMemos(store, action);
      break;

    case 'DESTROY_MEMO':
      destroyMemo(store, action);
      break;
  }
  next(action);
};

const readMemosSearch = (store: any, action: any) => {
  const METHOD = 'readMemosSearch';
  console.log(MIDDLEWARE + ':' + 'Call API: GetMemosSearch');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetMemosSearch();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.keyword, action.offset, store.getState().Account).then(
        memos => {
          store.dispatch(successReadMemosSearch(memos));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const readMemosRelated = (store: any, action: any) => {
  const METHOD = 'readMemosRelated';
  console.log(MIDDLEWARE + ':' + 'Call API: GetMemosRelated');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetMemosRelated();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.offset, action.limit, store.getState().Account).then(
        memos => {
          store.dispatch(successReadMemosRelated(memos));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const readMemosGroup = (store: any, action: any) => {
  const METHOD = 'readMemosGroup';
  console.log(MIDDLEWARE + ':' + 'Call API: GetMemosGroup');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetMemosGroup();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api
        .execute(
          action.group,
          action.offset,
          action.limit,
          store.getState().Account
        )
        .then(
          memos => {
            store.dispatch(successReadMemosByGroup(memos));
            store.dispatch(finishCalling(MIDDLEWARE + METHOD));
          },
          errorMessage => {
            store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
          }
        );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const readMemosDeadline = (store: any, action: any) => {
  const METHOD = 'readMemosDeadline';
  console.log(MIDDLEWARE + ':' + 'Call API: GetMemosDeadline');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetMemosDeadline();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.deadline, store.getState().Account).then(
        memos => {
          store.dispatch(successReadMemosByDeadline(memos));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const readMemosDiff = (store: any, action: any) => {
  const METHOD = 'readMemosDiff';
  console.log(MIDDLEWARE + ':' + 'Call API: GetMemosDiff');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetMemosDiff();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(store.getState().Account).then(
        memos => {
          store.dispatch(successReadMemosDiff(memos));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const readMemo = (store: any, action: any) => {
  const METHOD = 'readMemo';
  console.log(MIDDLEWARE + ':' + 'Call API: GetMemo');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetMemo();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.memo, store.getState().Account).then(
        memo => {
          store.dispatch(successReadMemo(memo));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const createMemo = (store: any, action: any) => {
  const METHOD = 'createMemo';
  console.log(MIDDLEWARE + ':' + 'Call API: PostMemo');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new PostMemo();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.memo, store.getState().Account).then(
        memo => {
          store.dispatch(successCreateMemo(memo));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const updateMemo = (store: any, action: any) => {
  const METHOD = 'updateMemo';
  console.log(MIDDLEWARE + ':' + 'Call API: PutMemo');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new PutMemo();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.memo, store.getState().Account).then(
        memo => {
          store.dispatch(successUpdateMemo(memo));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const updateMemos = (store: any, action: any) => {
  const METHOD = 'updateMemos';
  console.log(MIDDLEWARE + ':' + 'Call API: PutMemos');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      action.memos.map((memo: any) => {
        const api = new PutMemo();
        api.execute(memo, store.getState().Account).then(
          m => {
            store.dispatch(successUpdateMemo(m));
            store.dispatch(finishCalling(MIDDLEWARE + METHOD));
          },
          errorMessage => {
            store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
          }
        );
      });
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const destroyMemo = (store: any, action: any) => {
  const METHOD = 'destroyMemo';
  console.log(MIDDLEWARE + ':' + 'Call API: DeleteMemo');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new DeleteMemo();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.memo, store.getState().Account).then(
        memo => {
          store.dispatch(successDestroyMemo(action.memo));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

export default memosMiddleware;



// WEBPACK FOOTER //
// ./src/middlewares/memos.ts